import { TypeAsserter } from '@attain-apps/type-guards'

import * as core from '../../core'

export type JobTitle = core.common.Identified<JobTitle.Id> &
  core.common.Named &
  core.common.Coded &
  core.common.Described.Optionally

export namespace JobTitle {
  export type Id = core.dms.data.Record.Id
  export namespace Id {
    export const isId = core.dms.data.Record.Id.isId
    export const assertIsId: TypeAsserter<Id> = TypeAsserter.Factory.from(isId)
  }
}
